import { NavigationContainer } from "@/components/NavigationButton";
import { TableContainer } from "@/components/Table";
import { graphql } from "@/config/graphql";
import { safeNumber } from "@/utils/number";
import { useMutation, useQuery } from "@apollo/client";
import { Box, CircularProgress, Typography, styled } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { BatchControlTable } from "../BatchControlReport/components/BatchControlTable";
import { ProductionTable } from "../ProductionReport/components/ProductionTable";
import { SuppliesTable } from "../SuppliesReport/components/SuppliesTable";
import { FuelTable } from "../FuelReport/components/FuelTable";
import { TransportationTable } from "../TransportationControlReport/components/TransportationTable";

const Header = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
`;

const publishReportMutation = graphql(`
  mutation publishReport($params: PublishReportParams!) {
    publishReport(params: $params) {
      id
      comments
    }
  }
`);
const currentReport = graphql(`
  query currentReport($params: ReportParams!) {
    report(params: $params) {
      id
      comments

      fuelControlDetails {
        id
        resourceName
        initialHourometer
        finalHourometer
        diesel
        dieselHourometer
        dieselLastHourometer
        hours
        performance
        resourceDetail
      }
      supplyDetails {
        id
        resourceName
        resourceId
        initialQuantity
        finalQuantity
        incomeQuantity
        consumedQuantity
        photoUrl
      }
      productionDetails {
        id
        resource {
          id
          name
        }
        sellQuantity
        destination {
          id
          code
          name
          type
        }
      }
      transportationControlDetails {
        id
        plate
        diesel
        lastOdometer
        chargeOdometer
        kms
        performance
      }
      batchControlDetails {
        id
        initialHourometer
        finalHourometer
        waste
      }
    }
  }
`);

export const ReportSummary = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { data } = useQuery(currentReport, {
    variables: {
      params: {
        id: safeNumber(params.id),
      },
    },
  });
  const [publishReport, { loading: isPublishing }] = useMutation(
    publishReportMutation,
    { variables: { params: { reportId: safeNumber(params.id) } } }
  );

  const goBack = () => navigate(`/formulario-reporte/${params.id}/comentarios`);
  const goNext = async () => {
    await publishReport();
    toast.success("Reporte publicado exitosamente");
    navigate(`/`);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        marginBottom: 12,
        marginTop: 12,
      }}
    >
      <Header>
        <Typography variant="h5" fontWeight={"bold"}>
          RESUMEN
        </Typography>
      </Header>
      <TableContainer>
        <ProductionTable showPerformance />
      </TableContainer>
      <TableContainer>
        <BatchControlTable />
      </TableContainer>
      <TableContainer>
        <SuppliesTable />
      </TableContainer>
      <TableContainer>
        <FuelTable />
      </TableContainer>
      <TableContainer>
        <TransportationTable />
      </TableContainer>
      <Typography variant="h6">Comentarios</Typography>
      <Typography whiteSpace={"break-spaces"}>
        {data?.report.comments}
      </Typography>
      <NavigationContainer
        handleNext={goNext}
        handlePrev={goBack}
        nextComponent={
          <>
            PUBLICAR{" "}
            {isPublishing && (
              <CircularProgress size={20} sx={{ marginLeft: 1 }} />
            )}
          </>
        }
      />
    </Box>
  );
};
